import React, { useEffect } from 'react';
import { ClockIcon, MapPinIcon } from 'lucide-react';
import { articleBlocks, articleMeta } from '../data/article';
import { ArticleBody } from '../components/ArticleBody';
export function Advertorial() {
  useEffect(() => {
    document.title = articleMeta.title;
  }, []);
  return <div id="top" className="min-h-full w-full bg-paper-canvas" data-id="element-57" data-mp="1js20uv8mub8f">
      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12" data-id="element-58" data-mp="1jp64hbcfnum3">
        <article className="mx-auto w-full max-w-story bg-paper px-5 py-8 shadow-sm sm:px-10 sm:py-12" data-id="element-59" data-mp="m5cw4dmjpkiv">
          <p className="font-sans text-[11px] font-bold uppercase tracking-widest text-forest-mid" data-id="element-60" data-mp="r34mv4bgf0lh">
            {articleMeta.kicker}
          </p>
          <h1 className="mt-3 font-serif text-[32px] font-bold leading-[1.15] text-forest sm:text-[40px]" data-id="element-61" data-mp="10t6a5tvzgezc">
            {articleMeta.title}
          </h1>
          <p className="mt-4 font-serif text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-62" data-mp="3d0kt1dwz8wl">
            {articleMeta.standfirst}
          </p>

          <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-1 border-y border-forest-line py-3 font-sans text-[13px] text-ink-faint" data-id="element-63" data-mp="2tw3zw8yd6867">
            <span className="font-semibold text-ink" data-id="element-64" data-mp="2ox131bsjf89b">
              By {articleMeta.author}
            </span>
            <span className="flex items-center gap-1" data-id="element-65" data-mp="2k3ohjaj5nhks">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="2g4z4xk5xy427" />
              {articleMeta.location}
            </span>
            <span className="flex items-center gap-1" data-id="element-67" data-mp="2b6nw9crdtzlk">
              <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="265gqtkcppci2" />
              {articleMeta.readTime}
            </span>
            <span data-id="element-69" data-mp="217yhhsus8v9j">{articleMeta.date}</span>
          </div>

          <figure className="mt-6" data-id="element-70" data-mp="1x5bkzen62m60">
            <video src={articleMeta.heroVideo} className="w-full rounded-sm border border-forest-line bg-black object-cover" autoPlay muted loop playsInline data-id="element-71" data-mp="1x6d5e9q2ol0e" />
          </figure>

          <div className="mt-8" data-id="element-72" data-mp="1ow5rsuw7fnbz">
            <ArticleBody blocks={articleBlocks} data-id="element-73" data-mp="1ovw278f2ni6t" />
          </div>
        </article>
      </main>
    </div>;
}